import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EncryptService {
  private cryptoKey: CryptoKey | null = null;

  private async getKey(): Promise<CryptoKey> {
    if (this.cryptoKey) return this.cryptoKey;

    // SHA-256 of the key string — must match backend's key exactly
    const raw = new TextEncoder().encode(environment.orgEncryptionKey);
    const hash = await crypto.subtle.digest('SHA-256', raw);

    this.cryptoKey = await crypto.subtle.importKey('raw', hash, { name: 'AES-CBC', length: 256 }, false, ['encrypt']);
    return this.cryptoKey;
  }

  async encrypt(organisationId: number): Promise<string> {
    const key = await this.getKey();

    // Random 16-byte IV
    const iv = crypto.getRandomValues(new Uint8Array(16));

    // Encode orgId as 4-byte little-endian (matches BitConverter.GetBytes on .NET)
    const plain = new Uint8Array(4);
    new DataView(plain.buffer).setInt32(0, organisationId, true /* little-endian */);

    const cipherBuffer = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, key, plain);

    // Combine IV + cipher
    const cipher = new Uint8Array(cipherBuffer);
    const combined = new Uint8Array(iv.length + cipher.length);
    combined.set(iv, 0);
    combined.set(cipher, iv.length);

    // Base64url encode, no padding — matches backend TrimEnd('=').Replace('+','-').Replace('/','_')
    return btoa(String.fromCharCode(...combined))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }
}